// @flow
import Container from './container'
export default (store) => ({
  path: 'logout',
  element: <Container />,
})
